import roundTo from 'round-to'

class DashboardCurrentReadings {

  sensor = null;

  constructor ($container) {
    this.$container = $container;
  }

  render(sensor) {

    if(!this.sensor || this.sensor.id !== sensor.id) {

      this.sensor = sensor;
      this.readings = null;

      let version = parseInt(sensor.version);

      if(
        sensor.sensor_id.startsWith("EXAF") ||
        sensor.TC_SKIN && sensor.TC_SKIN === 'CLAMP'
      ) {
        this.CLAMP_READINGS(sensor);
      } else if (version >= 3000) {
        this.V3_READINGS(sensor);
      } else if (sensor.TC_M && sensor.TC_M == 1 && sensor.TC_SKIN && sensor.TC_SKIN === 'WINE_BOTTLE') {
        this.WINE_BOTTLE_READINGS(sensor);
      } else if (sensor.TC_M && sensor.TC_M == 1 && sensor.TC_SKIN && sensor.TC_SKIN === 'BUFFER_BOTTLE') {
        this.BUFFER_BOTTLE_READINGS(sensor);
      } else if (sensor.TC_M && sensor.TC_M == 1) {
        this.TC_Readings(sensor);
      } else {
        this.DHT_Readings(sensor);
      }

    } else {
      this.update(this.sensor, this.readings);
    }

  }

  updateAnimate($el, value) {

    let currentValue = $el.html();
    $el.html(value);

    if(!currentValue) {
      console.log($el, currentValue, value);
      return;
    }

    const modifiedCurrentValue = currentValue.replace('&deg;', '').replace(/[^a-z0-9]+/g, '');
    const modifiedValue = value.replace('&deg;', '').replace(/[^a-z0-9]+/g, '');

    if(modifiedCurrentValue != modifiedValue) {

      $el.addClass('animate');

      setTimeout(() => {
        // remove .animate
        $el.removeClass('animate');
      }, 400);

    }

  }

  update(sensor, readings) {

    this.readings = readings;

    console.log({sensor, readings});

    const lastCheckin = window.getUserTimezoneDate(sensor.last_checkin);

    if(this.isSensorNew(sensor)) {
      return;
    }

    let version = parseInt(sensor.version);

    if(
      (sensor.TC_M && sensor.TC_M == 1) ||
      sensor.sensor_id.startsWith("EXAF") ||
      version >= 3000 ||
      sensor.TC_SKIN && sensor.TC_SKIN === 'CLAMP'
    ) {

      const $readingLastTime = this.$container.find(`.tc-current-reading-time`);
      let lastCheckinStr = `<i class="far fa-clock"></i> Last Reading: 
      ${lastCheckin.format('MMM D, Y') + ' ' + lastCheckin.format('h:mm a')}`;

      this.updateAnimate($readingLastTime, lastCheckinStr);

      [
        "tcTemp",
        "tcTemp2",
        "temperature",
        "humidity",
      ].forEach(type => {

        const $reading = this.$container.find(`.tc-current-reading[data-for="${type}"]`);
        const $readingLastValue = $reading.find(`.tc-current-reading__value`);

        console.log($reading, $readingLastValue);

        if($reading) {

          const $high = $reading.find('.tc-current-reading__stat__value[data-for="high"]');
          const $low = $reading.find('.tc-current-reading__stat__value[data-for="low"]');
          const $average = $reading.find('.tc-current-reading__stat__value[data-for="average"]');

          if(readings && readings[type]) {

            console.log(type, readings[type]);

            this.updateAnimate($high, this.renderReading(type, readings[type].high));
            this.updateAnimate($low, this.renderReading(type, readings[type].low));
            this.updateAnimate($average, this.renderReading(type, readings[type].average));

            switch(type) {
              case("tcTemp"):
                this.updateAnimate($readingLastValue, this.renderReading(type, sensor.last_tcTemp));
                break;
              case("tcTemp2"):
                this.updateAnimate($readingLastValue, this.renderReading(type, sensor.last_tcTemp2));
                break;
              case("temperature"):
                this.updateAnimate($readingLastValue, this.renderReading(type, sensor.last_temp));
                break;
              case("humidity"):
                this.updateAnimate($readingLastValue, this.renderReading(type, sensor.last_humidity));
                break;
            }

          } else {
            this.updateAnimate($high, '-');
            this.updateAnimate($low, '-');
            this.updateAnimate($average, '-');
          }
        }

      });

    } else {

      let lastCheckinStr = lastCheckin.format('MMM D, Y') + '<br />' + lastCheckin.format('h:mm a');

      [
        "temperature",
        "humidity",
      ].forEach(type => {

        const $reading = this.$container.find(`.dashboard-lite__current-reading[data-for="${type}"]`);
        const $readingLastValue = $reading.find(`.dashboard-lite__current-reading-last-value`);
        let $readingLastTime = $reading.find(`.dashboard-lite__current-reading-last__time`);

        this.updateAnimate($readingLastTime, lastCheckinStr);

        if($reading) {

          const $high = $reading.find('.dashboard-lite__current-reading-stat__value[data-for="high"]');
          const $low = $reading.find('.dashboard-lite__current-reading-stat__value[data-for="low"]');
          const $average = $reading.find('.dashboard-lite__current-reading-stat__value[data-for="average"]');

          if(readings && readings[type]) {

            this.updateAnimate($high, this.renderReading(type, readings[type].high));
            this.updateAnimate($low, this.renderReading(type, readings[type].low));
            this.updateAnimate($average, this.renderReading(type, readings[type].average));


            if(type === 'temperature') {

              this.updateAnimate($readingLastValue, this.renderReading(type, sensor.last_temp));

            } else if(type === 'humidity') {

              this.updateAnimate($readingLastValue, this.renderReading(type, sensor.last_humidity));

            }

          } else {
            this.updateAnimate($high, '-');
            this.updateAnimate($low, '-');
            this.updateAnimate($average, '-');
          }
        }

      });

    }

  }


  renderReading(field, value) {

    if(typeof value == 'undefined' || value == 'n') {
      return 'N/A';
    }

    switch(field) {
      case("tcTemp"):
      case("tcTemp2"):
      case("temperature"):
        return `${window.celsiusToUserTemp(value, 1)}&deg;${window.getUserTempPref()}`;
        break;

      case("humidity"):
        return `${roundTo(value, 1)}%`;
        break;

    }

    return 'N/A';

  }

  TC_Readings_Stats() {
    return `
    <div class="tc-current-reading__stats">
        <div class="tc-current-reading__stat" data-for="high">
          <div class="tc-current-reading__stat__label">
            High
          </div>
          <div class="tc-current-reading__stat__value" data-for="high">
            -
          </div>
        </div>
        <div class="tc-current-reading__stat" data-for="low">
          <div class="tc-current-reading__stat__label">
            Low
          </div>
          <div class="tc-current-reading__stat__value" data-for="low">
            -
          </div>
        </div>
        <div class="tc-current-reading__stat" data-for="average">
          <div class="tc-current-reading__stat__label">
            Avg
          </div>
          <div class="tc-current-reading__stat__value" data-for="average">
            -
          </div>
        </div>
      </div>
    `;
  }

  isSensorNew(sensor) {

    if(sensor.last_temp == 0 && sensor.last_humidity == 0 && sensor.last_voltage == 0) {
      return true;
    }

    return false;

  }

  New_Sensor_Template() {
    this.$container.html(`
    <div class="dashboard-new-sensor">
      <div class="dashboard-new-sensor-content">
        <div class="dashboard-new-sensor__message">
          <h2 class="heading--regular">Initializing Sensor</h2>
            <p class="lead">
            Thank you for your Temp Stick purchase, your sensor is initializing; allow up to 2 minutes before its first reading shows up.  You should take this
            time to review your sensor settings such as how often it sends readings.
            </p>
            
            <p class="lead text--grey">If you haven't yet created any <a style="text-decoration: underline;" href="${window.site.home}/alerts">Alerts</a> for your sensor, you should do this now too.</p>
            
            <a class="button button--medium" href="${window.site.home}/sensors">
              Review Sensor Settings
            </a>
        </div>
      </div>
    </div>
    `);
  }

  WINE_BOTTLE_READINGS(sensor) {

    if(this.isSensorNew(sensor)) {
      this.New_Sensor_Template();
      return;
    }

    this.$container.toggleClass('is-tc', true);

    const lastCheckin = window.getUserTimezoneDate(sensor.last_checkin);
    const lastCheckinStr = lastCheckin.format('MMM D, Y') + ' ' + lastCheckin.format('h:mm a');

    const template = `
      
    <div class="tc-current-reading-time">
      <i class="far fa-clock"></i> Last Reading:  ${lastCheckinStr}
    </div>
    
    <div class="tc-current-reading" data-for="tcTemp">
      <div class="tc-current-reading__label">
        <div class="tc-current-reading__label__text">
          <img src="${window.site.home}/../assets/images/icon-wine-bottle-white.svg" width="25" height="25" /> Wine
        </div>
      </div>
      <div class="tc-current-reading__value">${this.renderReading("tcTemp", sensor.last_tcTemp)}</div>
      ${this.TC_Readings_Stats()}
    </div>

    <div class="tc-current-reading" data-for="temperature">
      <div class="tc-current-reading__label">
        <img src="/assets/images/icon-sensors-white.svg" data-for="unit" width="20" height="20"> Temp
      </div>
      <div class="tc-current-reading__value">${this.renderReading("temperature", sensor.last_temp)}</div>
      ${this.TC_Readings_Stats()}
    </div>

    <div class="tc-current-reading" data-for="humidity">
      <div class="tc-current-reading__label">
        <i class="fas fa-tint" aria-hidden="true"></i> Humidity
      </div>
      <div class="tc-current-reading__value">${this.renderReading("humidity", sensor.last_humidity)}</div>
      ${this.TC_Readings_Stats()}
    </div>
    `;

    this.$container.html(template);

  }

  BUFFER_BOTTLE_READINGS(sensor) {

    if(this.isSensorNew(sensor)) {
      this.New_Sensor_Template();
      return;
    }

    this.$container.toggleClass('is-tc', true);

    const lastCheckin = window.getUserTimezoneDate(sensor.last_checkin);
    const lastCheckinStr = lastCheckin.format('MMM D, Y') + ' ' + lastCheckin.format('h:mm a');

    const template = `
      
    <div class="tc-current-reading-time">
      <i class="far fa-clock"></i> Last Reading:  ${lastCheckinStr}
    </div>
    
    <div class="tc-current-reading" data-for="tcTemp">
      <div class="tc-current-reading__label">
        <div class="tc-current-reading__label__text">
          <img src="${window.site.home}/../assets/images/icon-buffer-bottle-white.svg" width="25" height="25" /> Bottle
        </div>
      </div>
      <div class="tc-current-reading__value">${this.renderReading("tcTemp", sensor.last_tcTemp)}</div>
      ${this.TC_Readings_Stats()}
    </div>

    <div class="tc-current-reading" data-for="temperature">
      <div class="tc-current-reading__label">
        <img src="/assets/images/icon-sensors-white.svg" data-for="unit" width="20" height="20"> Temp
      </div>
      <div class="tc-current-reading__value">${this.renderReading("temperature", sensor.last_temp)}</div>
      ${this.TC_Readings_Stats()}
    </div>

    <div class="tc-current-reading" data-for="humidity">
      <div class="tc-current-reading__label">
        <i class="fas fa-tint" aria-hidden="true"></i> Humidity
      </div>
      <div class="tc-current-reading__value">${this.renderReading("humidity", sensor.last_humidity)}</div>
      ${this.TC_Readings_Stats()}
    </div>
    `;

    this.$container.html(template);

  }

  CLAMP_READINGS(sensor) {

    if(this.isSensorNew(sensor)) {
      this.New_Sensor_Template();
      return;
    }

    this.$container.toggleClass('is-tc', true);

    const lastCheckin = window.getUserTimezoneDate(sensor.last_checkin);
    const lastCheckinStr = lastCheckin.format('MMM D, Y') + ' ' + lastCheckin.format('h:mm a');

    const template = `
      
    <div class="tc-current-reading-time">
      <i class="far fa-clock"></i> Last Reading:  ${lastCheckinStr}
    </div>
    
    <div class="tc-current-reading" data-for="tcTemp">
      <div class="tc-current-reading__label">
        <div class="tc-current-reading__label__text">
          <img src="${window.site.home}/../assets/images/icon-clamp-white.svg" width="25" height="25" /> Clamp
        </div>
      </div>
      <div class="tc-current-reading__value">${this.renderReading("tcTemp", sensor.last_tcTemp)}</div>
      ${this.TC_Readings_Stats()}
    </div>

    <div class="tc-current-reading" data-for="temperature">
      <div class="tc-current-reading__label">
        <img src="/assets/images/icon-sensors-white.svg" data-for="unit" width="20" height="20"> Temp
      </div>
      <div class="tc-current-reading__value">${this.renderReading("temperature", sensor.last_temp)}</div>
      ${this.TC_Readings_Stats()}
    </div>

    <div class="tc-current-reading" data-for="humidity">
      <div class="tc-current-reading__label">
        <i class="fas fa-tint" aria-hidden="true"></i> Humidity
      </div>
      <div class="tc-current-reading__value">${this.renderReading("humidity", sensor.last_humidity)}</div>
      ${this.TC_Readings_Stats()}
    </div>
    `;

    this.$container.html(template);

  }

  V3_PROBES(sensor) {

    let html = "";

    html += `
    <div class="tc-current-reading" data-for="tcTemp">
      <div class="tc-current-reading__label">
        <div class="tc-current-reading__label__text">
          <img src="${window.site.home}/../assets/images/icon-tc-probe-white.svg" width="20" height="20" /> Probe (1)
        </div>
      </div>
      <div class="tc-current-reading__value">${this.renderReading("tcTemp", sensor.last_tcTemp)}</div>
      ${this.TC_Readings_Stats()}
    </div>
    `

    if(sensor.last_tcTemp2) {
      html += `
      <div class="tc-current-reading" data-for="tcTemp2">
        <div class="tc-current-reading__label">
          <div class="tc-current-reading__label__text">
            <img src="${window.site.home}/../assets/images/icon-tc-probe-white.svg" width="20" height="20" /> Probe (2)
          </div>
        </div>
        <div class="tc-current-reading__value">${this.renderReading("tcTemp", sensor.last_tcTemp2)}</div>
        ${this.TC_Readings_Stats()}
      </div>
      `
    }

    return html;

  }

  V3_READINGS(sensor) {

    if(this.isSensorNew(sensor)) {
      this.New_Sensor_Template();
      return;
    }

    this.$container.toggleClass('is-tc', true);

    const lastCheckin = window.getUserTimezoneDate(sensor.last_checkin);
    const lastCheckinStr = lastCheckin.format('MMM D, Y') + ' ' + lastCheckin.format('h:mm a');

    const template = `
      
    <div class="tc-current-reading-time">
      <i class="far fa-clock"></i> Last Reading:  ${lastCheckinStr}
    </div>
    
    ${this.V3_PROBES(sensor)}

    <div class="tc-current-reading" data-for="temperature">
      <div class="tc-current-reading__label">
        <img src="/assets/images/icon-sensors-white.svg" data-for="unit" width="20" height="20"> Temp
      </div>
      <div class="tc-current-reading__value">${this.renderReading("temperature", sensor.last_temp)}</div>
      ${this.TC_Readings_Stats()}
    </div>

    <div class="tc-current-reading" data-for="humidity">
      <div class="tc-current-reading__label">
        <i class="fas fa-tint" aria-hidden="true"></i> Humidity
      </div>
      <div class="tc-current-reading__value">${this.renderReading("humidity", sensor.last_humidity)}</div>
      ${this.TC_Readings_Stats()}
    </div>
    `;

    this.$container.html(template);

  }

  TC_Readings(sensor) {

    if(this.isSensorNew(sensor)) {
      this.New_Sensor_Template();
      return;
    }

    this.$container.toggleClass('is-tc', true);

    const lastCheckin = window.getUserTimezoneDate(sensor.last_checkin);
    const lastCheckinStr = lastCheckin.format('MMM D, Y') + ' ' + lastCheckin.format('h:mm a');

    const template = `
      
    <div class="tc-current-reading-time">
      <i class="far fa-clock"></i> Last Reading:  ${lastCheckinStr}
    </div>
    
    <div class="tc-current-reading" data-for="tcTemp">
      <div class="tc-current-reading__label">
        <div class="tc-current-reading__label__text">
          <img src="${window.site.home}/../assets/images/icon-tc-probe-white.svg" width="20" height="20" /> Probe
        </div>
      </div>
      <div class="tc-current-reading__value">${this.renderReading("tcTemp", sensor.last_tcTemp)}</div>
      ${this.TC_Readings_Stats()}
    </div>

    <div class="tc-current-reading" data-for="temperature">
      <div class="tc-current-reading__label">
        <img src="/assets/images/icon-sensors-white.svg" data-for="unit" width="20" height="20"> Temp
      </div>
      <div class="tc-current-reading__value">${this.renderReading("temperature", sensor.last_temp)}</div>
      ${this.TC_Readings_Stats()}
    </div>

    <div class="tc-current-reading" data-for="humidity">
      <div class="tc-current-reading__label">
        <i class="fas fa-tint" aria-hidden="true"></i> Humidity
      </div>
      <div class="tc-current-reading__value">${this.renderReading("humidity", sensor.last_humidity)}</div>
      ${this.TC_Readings_Stats()}
    </div>
    `;

    this.$container.html(template);

  }

  DHT_Readings(sensor) {

    if(this.isSensorNew(sensor)) {
      this.New_Sensor_Template();
      return;
    }

    this.$container.toggleClass('is-tc', false);

    const lastCheckin = window.getUserTimezoneDate(sensor.last_checkin);
    const lastCheckinStr = lastCheckin.format('MMM D, Y') + '<br>' + lastCheckin.format('h:mm a');

    const template = `
      <div class="dashboard-lite__current-reading" data-for="temperature">
        <div class="dashboard-lite__current-reading-heading">
          <i class="fas fa-thermometer-three-quarters"></i> Temperature
        </div>
        <div class="dashboard-lite__current-reading-last">
          <div class="dashboard-lite__current-reading-last__value">
            <div class="dashboard-lite__current-reading-last-label">Last Reading</div>
            <div class="dashboard-lite__current-reading-last-value">
              ${window.celsiusToUserTemp(sensor.last_temp, 1)}&deg;${window.getUserTempPref()}
            </div>
          </div>
          <div class="dashboard-lite__current-reading-last__time">
            ${lastCheckinStr}
          </div>
        </div>
        <div class="dashboard-lite__current-reading-stats">
          <div class="dashboard-lite__current-reading-stat">
            <div class="dashboard-lite__current-reading-stat__label">High</div>
            <div class="dashboard-lite__current-reading-stat__value" data-for="high">-</div>
          </div>
          <div class="dashboard-lite__current-reading-stat">
            <div class="dashboard-lite__current-reading-stat__label">Low</div>
            <div class="dashboard-lite__current-reading-stat__value" data-for="low">-</div>
          </div>
          <div class="dashboard-lite__current-reading-stat">
            <div class="dashboard-lite__current-reading-stat__label">Average</div>
            <div class="dashboard-lite__current-reading-stat__value" data-for="average">-</div>
          </div>
        </div>
      </div>
      
      <div class="dashboard-lite__current-reading" data-for="humidity">
        <div class="dashboard-lite__current-reading-heading">
          <i class="fas fa-tint"></i> Humidity
        </div>
        <div class="dashboard-lite__current-reading-last">
          <div class="dashboard-lite__current-reading-last__value">
            <div class="dashboard-lite__current-reading-last-label">Last Reading</div>
            <div class="dashboard-lite__current-reading-last-value">
              ${roundTo(sensor.last_humidity, 1)}%
            </div>
          </div>
          <div class="dashboard-lite__current-reading-last__time">
            ${lastCheckinStr}
          </div>
        </div>
        <div class="dashboard-lite__current-reading-stats">
         <div class="dashboard-lite__current-reading-stat">
            <div class="dashboard-lite__current-reading-stat__label">High</div>
            <div class="dashboard-lite__current-reading-stat__value" data-for="high">-</div>
          </div>
          <div class="dashboard-lite__current-reading-stat">
            <div class="dashboard-lite__current-reading-stat__label">Low</div>
            <div class="dashboard-lite__current-reading-stat__value" data-for="low">-</div>
          </div>
          <div class="dashboard-lite__current-reading-stat">
            <div class="dashboard-lite__current-reading-stat__label">Average</div>
            <div class="dashboard-lite__current-reading-stat__value" data-for="average">-</div>
          </div>
        </div>
      </div>
    `;

    this.$container.html(template);

  }

}

export default DashboardCurrentReadings;
